<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Locker</h4>
      </div>
      <div>
        <fg-input
          name="location"
          label="Local"
          v-model="model.location"
          v-validate="modelValidations.name"
          :error="getError('location')"
        ></fg-input>

        <fg-input name="name" label="Nome" v-model="model.name"></fg-input>

        <fg-input name="address" label="Endereço do local" v-model="model.location_address"></fg-input>

        <fg-input name="vpn_key" label="Chave da VPN" v-model="model.vpn_key"></fg-input>

        <fg-input name="mac" label="Endereço MAC" v-model="model.mac"></fg-input>

        <fg-input name="ip" label="Endereço IP" v-model="model.ip"></fg-input>

        <fg-input label="Última Conexão">
          <el-date-picker
            v-model="model.last_communication"
            type="datetime"
            format="dd/MM/yyyy HH:mm:ss"
            placeholder="Selecione"
          ></el-date-picker>
        </fg-input> 

          <fg-input name="payment" label="Pagamentos">
            <div>
              <l-switch v-model="model.payment"></l-switch>
            </div>
          </fg-input>

          <fg-input
            v-if="model.payment"
            name="company"
            label="Sistema de vendas">

            <el-select class=""
                        size="large"
                        style="width: 100%"
                        placeholder="Selecione o sistema de venda à ser utilizado"
                        v-model="model.payment_system">
              <el-option v-for="option in vmSystem"
                          class=""
                          :value="option.value"
                          :label="option.label"
                          :key="option.id">
              </el-option>
            </el-select>
          </fg-input>


        <fg-input name="maintence_pwd" label="Senha de Manutenção" type="number" v-model="model.maintence_pwd"></fg-input>

        <fg-input name="serial_term" label="Porta de comunicação do terminal de pagamento" v-model="model.serial_term"></fg-input>

        <fg-input name="serial_control" label="Serial da placa de controle" v-model="model.serial_control"></fg-input>

        <fg-input
          name="coils_shelf"
          label="Boxes por módulo"
          v-if="showItem"
          v-model="model.coil_per_shelf"
        ></fg-input>

        <fg-input 
          name="qtd_shelves"
          v-if="showNumbShelf" 
          label="Quantidade de modulos" 
          type="number" v-model="model.shelves_quantity"></fg-input>


        <fg-input
          name="itens_per_sale"
          label="Itens por Venda"
          v-model="model.itens_per_sale"
          v-validate="modelValidations.name"
          :error="getError('itens_per_sale')"
        ></fg-input>
        <fg-input name="id_externo" label="ID Externo" v-model="model.id_externo"></fg-input>
      </div>
    </card>

    <card>
      <div >
        <div v-for="i in numberShelf" :key='i.id'>
          <p style="margin-bottom: -20px; margin-top: 10px">Módulo  {{String.fromCharCode(i + 64)}}</p>
          
          <div class="row " style="">
            <fg-input
              v-for="n in 16"
              :key="n.id"
              name="coil"
              style="padding-left: 15px; margin-bottom: -10px"
              label="">
                <br>


              <l-button 
                        v-bind:class="{ checkColor }"
                        style="width: 40px; height: 40px; " 
                        ref="btn"
                        @click="setCoil(n + 16*(i-1))">{{n}}</l-button>&nbsp;

            </fg-input>
          </div>
        </div>
        <div v-if="numberShelf > 0" style="height: 25px"></div>
          <l-button wide type="primary" round @click="addShelf()" >
            <span class="btn-label">
              <i class="fa fa-plus"></i>
            </span>
              &nbsp;&nbsp;Adicionar Módulo
          </l-button> 

          <l-button wide type="danger" round 
                    @click="removeShelf()" v-if="numberShelf !== 0 && crud === 'Criar'"
                    style="margin-left: 20px">
            <span class="btn-label">
              <i class="fa fa-minus"></i>
            </span>
              &nbsp;&nbsp;Remover Módulo
          </l-button>

          <l-button wide type="danger" round 
                    @click="removeShelf()" v-if="crud === 'Editar' && numberShelf > originalShelf"
                    style="margin-left: 20px">
            <span class="btn-label">
              <i class="fa fa-minus"></i>
            </span>
              &nbsp;&nbsp;Remover Módulo
          </l-button>
          
      </div>
    </card>

    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  TimeSelect,
  Slider,
  Table,
  TableColumn
} from "element-ui";

import { Switch as LSwitch } from "src/components/index";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [Slider.name]: Slider,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    LSwitch
  },
  created() {
    if (this.$route.params.id) {
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
      if (this.$route.params.id) {
        this.$store.dispatch('lockers/get', {id: this.$route.params.id}).then(resp => {
          this.model = resp
        })
      }
      var ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) { 
        this.model.company = ciaID
      } else {
        ciaID = ''
      }
        this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID}).then(() => {
          this.$store.dispatch("products/variants/listSort",{sort: '?company=' + ciaID}).then(() => {
            this.$store.dispatch("modulos/listSort",{sort: '?company=' + ciaID}).then(() => {
              if (this.$route.params.id) {
                this.$store.dispatch("boxes/listSort", {sort: '?shelf__vm=' + this.$route.params.id + '&ordering=id' + '&page_size=161'}).then(() => {
                });
                setTimeout(() => {
                  this.coilsByShelf()                
                }, 1000);
              }
            });
          });
        });
  },
  computed: {
    users() {
      return this.$store.state.users.users;
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
    shelves() {
      return this.$store.state.modulos.modulos;
    },
    coils() {
      return this.$store.state.boxes.boxes;
    },
    productVariants() {
      return product => {
        const p = this.products.find(e => e.id == product) || {};
        const v = p.variants;
        return v;
      };
    },
    shelvesByMachine() {
      const shelves = [...this.$store.state.modulos.modulos];
      const byMachine = shelves.filter(e => e.vm === Number(this.$route.params.id));
      console.log({ byMachine });
      return byMachine;
    },
    coilsByShelf() {
      const coils = [...this.$store.state.boxes.boxes];
      const shelves = [...this.shelvesByMachine]
      const dateConverted = coils.map(v => {
        let expiration_date = v.expiration_date;
        if (v.expiration_date) {
          const d = v.expiration_date.split("-").join("/");
          expiration_date = d;
        }
        let letter, vm_position
        if(v.vm_position){
          letter = v.vm_position.charAt(0)
          vm_position = v.vm_position.substr(1)
        }
        return { ...v, expiration_date, letter, vm_position };
      });
      const byShelf = shelves.map(v => {
        const c = dateConverted.filter(e => e.shelf === v.id);
        
        return [...c];
      });
      if (this.crud === 'Editar') {
        for (let index = 0; index < byShelf.length; index++) {
          byShelf[index] = byShelf[index].sort((a,b) => (Number(a.vm_position) > Number(b.vm_position)) ? 1 : ((Number(b.vm_position) > Number(a.vm_position)) ? -1 : 0))
        }
        this.arrange(byShelf)
      }
      console.log('byshlef', byShelf)
      return byShelf;
    }
  },
  data() {
    return {
      crud: "Editar",
      vmSystem: [{value: 0, label: 'Nenhum'},
                  {value: 1, label: 'VM Pay'},
                  {value: 2, label: 'Vend Pago'},
                  {value: 3, label: 'Mercado Pago'},
                  {value: 4, label: 'Outro'}],
      showNumbShelf: false,
      result: [],
      originalShelf: Number,
      isActive: false,
      perCoil: [],
      numberShelf: 0,
      showBtn:false,
      model: {
        user: "",
        location: "",
        vpn_key: "",
        mac: "",
        ip: "",
        last_communication: "",
        coil_per_shelf: 16,
        perCoil: [],
        maintence_pwd: "",
        serial_term: "",
        itens_per_sale: "",
        id_externo: "",
        shelves_quantity: 10,
        payment: false,
      },
      modelValidations: {
        name: {
          required: true
        },
        price: {
          required: true,
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        }
      }
    };
  },
  mounted() {
    this.$watch('numberShelf', () => {
      this.checkColor()
    })

    this.featureFlag()
  },
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    addShelf () {
      this.numberShelf += 1 
      for (let index = 0 + 16*(this.numberShelf-1); index < 16*this.numberShelf; index++) {
        this.perCoil[index] = true
      }
      console.log('add', this.perCoil)
    },
    removeShelf () {
      this.numberShelf -= 1
      for (let index = (16*this.numberShelf+1); index < this.perCoil.length; index++) {
        this.perCoil.splice(index)
      }
      this.perCoil.splice(-1,1)
      console.log('remove', this.perCoil)
    },
    setCoil (n) {
      this.perCoil[n-1] = !this.perCoil[n-1]
      if (this.perCoil[n-1]) {
        this.$refs.btn[n-1].type = 'success'
      } else {
        this.$refs.btn[n-1].type = 'default'
      }
      console.log('setcoil', this.perCoil)
    },
    checkColor () {
      setTimeout(() => {
        for (let index = 0; index < this.perCoil.length; index++) {
          if (this.perCoil[index]) {
            this.$refs.btn[index].type = 'success'
          } else {
            this.$refs.btn[index].type = 'default'
          }        
        }
      }, 10);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    final () {
      var x
        for (let i = 0; i < this.perCoil.length; i++) {
          for (let index = 0; index <= this.numberShelf; index++) {
            if (16*index <= i){
              x = index
            } 
          this.result[i] = {value: this.perCoil[i],
                            shelf: x,
                            coil: i-x*16}
                                       
          }
      }
      console.log('final', this.result)
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (!this.model.updated) {
          this.model.last_communication = Date.now();
        }
        this.model.last_communication = new Date(
          this.model.last_communication
        ).toISOString();
          this.final()
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("lockers/create", { item: this.model })
            .then(resp => {
              let payload = { data: this.result, id: resp.id };
              this.$store.dispatch('lockers/create_shelf', payload).then(()=>{
                this.notifySuccess();
                this.$router.push(`/app/machines/lockers`);
              })
            });
        } else if (isValid && this.crud === "Editar") {
          this.$store
            .dispatch("lockers/update", { item: this.model })
            .then(resp => {
              console.log('resp', resp)
              if (resp.id) {
                let payload = { data: this.result, id: resp.id }
                this.$store.dispatch('lockers/create_shelf', payload).then(()=>{
                  this.notifySuccess();
                  this.$router.push(`/app/machines/lockers`);
                })
              } else {
                this.notifyError()
              }
            }); 
        }
      });
    },
    // color(value) {
    //   if (value <= 75) {
    //     return "slider-success";
    //   } else {
    //     return "slider-danger";
    //   }
    // },
    arrange (dados) {
      this.originalShelf = dados.length      
      for (let index = 0; index < dados.length; index++) {
        this.addShelf()
      }
      var x = 0
      // this.numberShelf = dados.length
      for (let index = 0; index < dados.length; index++) {
        for (let i = 0; i < dados[index].length; i++) {
          this.perCoil[x] =  dados[index][i].active
          x += 1
        }        
      }
    },
    featureFlag () {
      if (this.$store.state.auth.company == null) {
        this.showNumbShelf = true
      }
      console.log('flag',this.$store.state.general.flag )
      var y = this.$store.state.general.flag.filter(el => {
        if (el.vm == this.$route.params.id) {
          if (el.feature === "V01"){
            if (el.active === true) {
              this.showNumbShelf = true
            }
          }
        }
      })
    },
  }
};
</script>
<style scoped>
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
.card-header {
  display: flex;
}
.card-header button {
  margin-left: auto;
}
.table-responsive .form-group {
  margin: 0;
}
</style>
